import React from 'react';
import { useStyletron } from 'baseui';

const EmailAttachment = ({ fill }: { fill?: string }) => {
	const [css, theme]: [any, any] = useStyletron();
	if (!fill) {
		fill = theme.colors.primaryA;
	}

	return (
		<svg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M8.72064 1.01543C8.2919 1.06997 7.90157 1.29268 7.59596 1.59829L3.0534 6.14085C2.85318 6.34107 2.70006 6.59258 2.6541 6.872C2.51098 7.74208 3.25534 8.48741 4.12594 8.34641C4.40538 8.30116 4.65718 8.14857 4.85734 7.94841L9.00203 3.80372C9.08192 3.72383 9.08192 3.59433 9.00203 3.51445L8.71282 3.22523C8.63293 3.14534 8.50343 3.14534 8.42355 3.22523L4.23757 7.41123C4.15087 7.49771 4.03562 7.54546 3.91276 7.54546C3.66008 7.54546 3.45453 7.33951 3.45453 7.08642C3.45453 6.96418 3.50228 6.84912 3.58876 6.76242L8.2292 2.12199C8.42516 1.92605 8.68565 1.81818 8.9627 1.81818C9.53459 1.81818 10 2.2836 10 2.86967C10 3.14013 9.89654 3.3962 9.70839 3.59077L4.87145 8.59467C4.57867 8.89753 4.19883 9.11793 3.78064 9.16863C2.67164 9.30309 1.73322 8.39209 1.82431 7.26382C1.85884 6.83606 2.06953 6.44078 2.37299 6.13732L6.87191 1.6384C6.9518 1.55852 6.9518 1.42902 6.87191 1.34913L6.58269 1.05992C6.50281 0.98003 6.37331 0.98003 6.29342 1.05992L1.75086 5.60248C1.26678 6.08656 1.00013 6.72996 1 7.4361C0.999885 8.09787 1.27004 8.7411 1.73431 9.21268C2.84937 10.3453 4.48195 10.1745 5.40672 9.21818L10.2966 4.15926C10.633 3.8115 10.8182 3.35348 10.8182 2.8555C10.8182 1.75273 9.85121 0.871589 8.72064 1.01543Z'
				fill={fill}
				stroke={fill}
				strokeWidth='0.2'
			/>
		</svg>
	);
};

export default React.memo(EmailAttachment);
